(function () {
  var customUrl = '/pages/custom-bracelet';

  function fixNavLinks() {
    // Only touch header / drawer labels — do not rewrite main page CTAs
    document.querySelectorAll('header a, .menu-drawer a, .header__inline-menu a').forEach(function (a) {
      var label = (a.textContent || '').trim();
      if (/^catalog$/i.test(label)) {
        a.href = customUrl;
        a.textContent = 'Custom';
      }
    });

    document.querySelectorAll('header a[href*="/collections/all"], .menu-drawer a[href*="/collections/all"]').forEach(function (a) {
      var label = (a.textContent || '').trim();
      if (/catalog/i.test(label)) {
        a.href = customUrl;
      }
    });
  }

  function addMobileCustomBar() {
    if (!document.body.classList.contains('template-index')) return;
    if (document.querySelector('.moyshop-mobile-custom-bar')) return;

    var bar = document.createElement('div');
    bar.className = 'moyshop-mobile-custom-bar';
    bar.innerHTML =
      '<a class="moyshop-mobile-custom-bar__link" href="' +
      customUrl +
      '">Design Your Custom Bracelet</a>';
    document.body.appendChild(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      fixNavLinks();
      addMobileCustomBar();
    });
  } else {
    fixNavLinks();
    addMobileCustomBar();
  }

  document.addEventListener('shopify:section:load', fixNavLinks);
})();
